import Rest from "./BaseRest";
import axios from 'axios'
import DjangoRest, { integrationsRest } from "./DjanoBaseRest";

const resource = "members";

export default {
  SearchMembers(keywords) {
    return Rest.get(`${resource}?search=${keywords}`);
  },
  FetchMembers(keywords) {
    return Rest.get(`${resource}`);
  },
  FetchMembersCustom(queryString) {
    return Rest.get(`${resource}?${queryString}`);
  },
  FetchMember(id) {
    return Rest.get(`${resource}/${id}`);
  },
  StoreMember(member) {
    return Rest.post(`${resource}`, member);
  },
  UpdateMember(member) {
    return Rest.put(`${resource}/${member.id}`, member);
  },
  UpdateMemberV2(member) {
    return DjangoRest.post(`${resource}/${member.arrIndex}/`, member);
  },
  UpdateMemberInfo(payload) {
    return DjangoRest.post(`${resource}/update/`, payload);
  },
  DestroyMember(id) {
    return Rest.delete(`${resource}/${id}`);
  },
  UpdateHasPaymentMethodById(id, hasPaymentMethod) {
    return Rest.put(
      `${resource}/${id}/flag-has-payment-method`,
      hasPaymentMethod
    );
  },
  GetUnpaidInvoices(id) {
    return DjangoRest.post("get_unpaid_invoices/", { member_id: id });
  },
  SettleUnpaidInvoices(id) {
    return DjangoRest.post("run_charges_on_unpaid_invoices/", {
      member_id: id,
    });
  },
  PayInvoice(payload) {
    return DjangoRest.post("run_charge_on_invoice/", payload);
  },
  async GetPatientMatchesFromPMS(firstName, lastName, companyID) {
    try {
      const response = await integrationsRest.get(`/get-pms-matches?firstName=${firstName}&lastName=${lastName}&companyID=${companyID}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

    async GetOnePatientFromPMS(practiceID, pmsID) {
      try {
        const response = await integrationsRest.get(`/get-one-patient?practiceId=${practiceID}&pmsId=${pmsID}`);
        return response.data;
      } catch (error) {
        //console.error("Error in GetOnePatientFromPMS:", error);
        throw error;
      }
    },
};
